type FileMetadata = {
  type: string;
};

export const isImage = (file: FileMetadata) => {
  return file.type.split('/')[0] === 'image';
};

export const isPdf = (file: FileMetadata) => {
  return file.type.split('/')[1] === 'pdf';
};
